import styled from '@emotion/styled';
import { Stack } from '@mui/material';

export const UploadContainer = styled(Stack, {
  shouldForwardProp: (prop) => !['$isIdle', '$isDragging'].includes(prop),
})<{ $isIdle: boolean; $isDragging: boolean }>(({ theme, $isIdle, $isDragging }) => ({
  position: 'relative',
  borderRadius: '10px',
  background: theme.colors.background.canvas,
  border: `1px dashed ${$isDragging ? theme.colors.brand.solid : theme.colors.border.default}`,
  width: '100%',
  overflow: 'hidden',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: 234,
  cursor: $isIdle ? 'pointer' : 'default',
}));

export const UploadIconCircle = styled(Stack)(({ theme }) => ({
  width: 56,
  height: 56,
  borderRadius: '50%',
  background: theme.colors.white[4],
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));

export const BusinessCardPreview = styled('img')({
  width: 332,
  height: 192,
  borderRadius: '8px',
  objectFit: 'contain',
  display: 'block',
});
